export const de = {
  greeting: 'Hallo',
  updateAvailable: 'Neues Update verfügbar.',
  updateError: 'Fehler beim Aktualisieren!',
  errorBoundaryTitle: 'Ups!',
  errorBoundaryDescription:
    'Entschuldige, das hätte nicht passieren dürfen. Du kannst es erneut versuchen oder neu laden.',
  errorBoundaryRetry: 'Erneut versuchen',
  errorBoundaryReload: 'Neu laden',
  checkingForUpdates: 'Suche nach Updates …',
  noUpdateAvailable: 'Bereits auf dem neuesten Stand!',
  updateCheckFailed: 'Update aus unbekannten Gründen fehlgeschlagen.',
  noveltyPageHeader: 'Neuheiten',
  noItemsFound: 'Versuche andere Suchbegriffe und Filter.',
  noItemsFoundHeader: 'Kein Ergebnis',
  noItemsFoundHeaderMonthly: 'Keine Neuheiten für diesen Monat gefunden.',
  noItemsFoundWithFilter: 'Datenbank durchsuchen',
  noItemsFoundResetFilter: 'Filter zurückzusetzen',
  noItemsFoundEmptyCollection: 'Noch keine Einträge',
  noItemsFoundEmptyCustomList: 'Suche jetzt hier nach Einträgen für diese Liste.',
  noItemsInCollection: 'Scanne einen Barcode um etwa in deine Sammlung einzutragen!',
  volumePrefix: 'Band',
  collectionPrefix: 'Bundle',
  slipCasePrefix: 'Schuber',
  collectionEntryLineCompact: '%{prefix} · %{price} %{currency}',
  collectionEntryLineCompactNoPrice: '%{prefix}',
  prunedReleaseLabel: 'Release',
  listItemPrunedToast: '%{item} aus %{list} entfernt.',
  emptySlipcase: 'Leerschuber',
  collectionEntryLine: '%{prefix}%{number} (Bd. %{range}) · %{price} %{currency}',
  collectionEntryLineNoVolumes: '%{prefix}%{number} · %{price} %{currency}',
  collectionEntryLineVolumeCount: '%{prefix}%{number} (%{count} Bd.) · %{price} %{currency}',
  releaseItemTitleLine: 'Band %{number}',
  releaseItemTitleLineWithSuffix: 'Band %{number} · %{volumeSuffix}',
  collectionItemTitleLine: '%{prefix} %{number} (Bd. %{range})',
  collectionItemTitleLineNoVolumes: '%{prefix} %{number}',
  collectionItemTitleLineVolumeCount: '%{prefix} %{number} (%{count} Bd.)',
  collectionItemTitleLineNoNumber: '%{prefix} (Bd. %{range})',
  collectionItemTitleLineNoVolumesNoNumber: '%{prefix}',
  collectionItemTitleLineVolumeCountNoNumber: '%{prefix} (%{count} Bd.)',
  collectionRangeLabel: 'Band %{range}',
  addedTitledVolumesToCollection: {
    one: '%{title} · Band %{range} zur Sammlung hinzugefügt',
    other: '%{title} · Bände %{range} zur Sammlung hinzugefügt',
  },
  collectionRangeLabelWithTitle: '%{title} · Band %{range}',
  detailsListPostLine: '%{date} · %{price} %{currency}',
  collectionDetailEntryLine: '%{prefix} (Bd. %{range}) · %{price} %{currency} · %{date}',
  collectionDetailEntryLineNoVolumes: '%{prefix} · %{price} %{currency} · %{date}',
  collectionDetailEntryLineVolumeCount: '%{prefix} (%{count} Bd.) · %{price} %{currency} · %{date}',
  releaseEntryPriceLine: '%{prefix} %{number} · %{price} %{currency}',
  releaseEntryPriceLineWithSuffix: '%{prefix} %{number} · %{volumeSuffix} · %{price} %{currency}',
  releaseEntryLine: '%{prefix} %{number}',
  releaseEntryLineWithSuffix: '%{prefix} %{number} · %{volumeSuffix}',
  collectionEntryLineNoPrice: '%{prefix}%{number} (Bd. %{range})',
  collectionEntryLineNoVolumesNoPrice: '%{prefix}%{number}',
  collectionEntryLineVolumeCountNoPrice: '%{prefix}%{number} (%{count} Bd.)',
  collectionDetailEntryLineNoPrice: '%{prefix} (Bd. %{range}) · %{date}',
  collectionDetailEntryLineNoVolumesNoPrice: '%{prefix} · %{date}',
  collectionDetailEntryLineVolumeCountNoPrice: '%{prefix} (%{count} Bd.) · %{date}',
  detailsListPostLineNoPrice: '%{date}',
  releaseEntryNameLine: '%{name} · %{price} %{currency}',
  publisherLine: '%{publisher}',
  publisherAndDateLine: '%{publisher} · %{date}',
  infoExtraHeader: 'Extras',
  infoExtraFirstEditionHeader: 'Extras (nur Erstauflage)',
  infoDescriptionHeader: 'Beschreibung',
  infoPublisherDescriptionHeader: 'Verlagsbeschreibung',
  infoArtistHeader: {
    one: 'Zeichner',
    other: 'Zeichner',
  },
  infoAuthorHeader: {
    one: 'Autor',
    other: 'Autoren',
  },
  infoTranslatorHeader: {
    one: 'Übersetzer',
    other: 'Übersetzer',
  },
  releaseEntryVolumeAmountLine: {
    one: '1 Band',
    other: '%{count} Bände',
  },
  releaseEntryVolumeAmountLineWithType: {
    one: '1 Band · %{type}',
    other: '%{count} Bände · %{type}',
  },
  filterChipBarClearAll: 'Alle löschen',
  listStatsLine: 'Reihen: %{series} · Bände: %{volumes}/%{released}',
  listSeriesLine: 'Reihen: %{series}',
  settingsPageLabel: 'Einstellungen',
  languagesGerman: 'Deutsch',
  languagesEnglish: 'Englisch',
  languagesSelect: 'Sprache auswählen',
  bottomNavNovelties: 'Neuheiten',
  bottomNavMyLists: 'Meine Listen',
  bottomNavExploration: 'Entdecke',
  bottomNavSettings: 'Einstellungen',
  bottomNavProfile: 'Profil',
  profilePageLabel: 'Profil',
  profileBiographyHeading: 'Biografie',
  profileBiographyEmpty: 'Noch keine Biografie hinzugefügt.',
  profileMemberSince: 'Mitglied seit %{date}',
  profileEditNameLabel: 'Namen bearbeiten',
  profileNameUpdateError: 'Name konnte nicht aktualisiert werden.',
  statisticsPageLabel: 'Statistiken',
  statisticsTabCollection: 'Sammelaktivität',
  statisticsTabReading: 'Leseaktivität',
  statisticsSectionGeneral: 'Allgemein',
  statisticsSectionSold: 'Verkauft',
  statisticsOwnedSeries: 'Reihen im Besitz',
  statisticsOwnedVolumes: 'Bände im Besitz',
  statisticsNewValue: 'Neuwert',
  statisticsSoldVolumes: 'Verkaufte Bände',
  statisticsSoldValue: 'Verkaufserlös',
  statisticsReadVolumes: 'Gelesene Bände',
  statisticsReadLast30Days: 'Gelesen (30 Tage)',
  statisticsAddedLast30Days: 'Hinzugefügt (30 Tage)',
  genericDropdownPlaceholder: 'Auswählen',
  genericSelectModalTitle: 'Bitte Wert auswählen',
  releaseEntryFilterHeader: 'Filtern',
  releaseEntrySortHeader: 'Sortieren',
  confirmDropdownSelection: 'Auswahl bestätigen',
  releaseEntryFilterMonthSelectionLabel: 'Monat',
  releaseEntryFilterMonthSelectionModalTitle: 'Monat auswählen',
  releaseEntryFilterYearSelectionLabel: 'Jahr',
  releaseEntryFilterYearSelectionModalTitle: 'Jahr auswählen',
  releaseEntryFilterPublisherSelectionLabel: 'Verlag',
  releaseEntryFilterPublisherSelectionModalTitle: 'Verlag auswählen',
  releaseEntryFilterMediumSelectionLabel: 'Medium',
  releaseEntryFilterMediumSelectionModalTitle: 'Medium auswählen',
  releaseEntryFilterTagSelectionLabel: 'Tags',
  releaseEntryFilterCuratedListSelectionLabel: 'Eigene',
  releaseEntryFilterPromotedTagSelectionLabel: 'Spezial',
  releaseEntryFilterDemographySelectionLabel: 'Zielgruppe',
  releaseEntryFilterPriceSelectionLabel: 'Preis',
  releaseEntryFilterPlaceholderAll: 'Alle',
  releaseEntryFilterShowMore: 'Andere',
  modalOkayButton: 'Okay',
  modalCancelButton: 'Abbruch',
  monthJanuary: 'Januar',
  monthFebruary: 'Februar',
  monthMarch: 'März',
  monthApril: 'April',
  monthMay: 'Mai',
  monthJune: 'Juni',
  monthJuly: 'Juli',
  monthAugust: 'August',
  monthSeptember: 'September',
  monthOctober: 'Oktober',
  monthNovember: 'November',
  monthDecember: 'Dezember',
  sortReleaseDateLabel: 'Erscheinungsdatum',
  sortPublisherLabel: 'Verlag',
  sortTitleLabel: 'Titel',
  sortPriceLabel: 'Preis',
  sortCollectionChangedLabel: 'Zuletzt aktualisiert',
  sortTotalVolumesLabel: 'Bandanzahl (Original)',
  sortTotalReleasedVolumesLabel: 'Bandanzahl (Deutschland)',
  sortCreationDateLabel: 'Hinzugefügt am',
  sortManualOrder: 'Manuelle Reihenfolge',
  noDateSetForRelease: 'Kein Datum verfügbar',
  registerButtonLabel: 'Registrieren',
  loginButtonLabel: 'Login',
  socialLoginButtonLabel: 'Weiter mit %{provider}',
  authPageSsoSeparatorLabel: 'oder',
  passwordRepeatMatchError: 'Passwörter stimmen nicht überein',
  authEmptyFieldError: 'Bitte fülle alle Felder aus',
  authEmailPlaceholder: 'E-Mail',
  authNicknamePlaceholder: 'Nickname',
  authPasswordPlaceholder: 'Passwort',
  authPasswordRepeatPlaceholder: 'Passwort wiederholen',
  authResponseEmailError: 'Ungültige E-Mail-Adresse',
  authResponsePasswordError:
    'Passwort muss mindestens 8 Zeichen lang sein sowie einen kleinen Buchstaben und eine Zahl enthalten.',
  authResponseErrorUnknown: 'Unbekannter Fehler, bitte kontaktiere uns!',
  authResponseLoginEmailPasswordError: 'E-Mail oder Passwort ist falsch',
  authResponseSignUpNotAllowed: 'Registrierung ist momentan nicht möglich',
  authResponseSignInNotAllowed: 'Anmeldung ist momentan nicht möglich',
  authSsoTimeout:
    '%{provider} hat zu lange gebraucht. Bitte überprüfe deine Verbindung und versuche es erneut.',
  authSsoFailed:
    'Anmeldung mit %{provider} fehlgeschlagen. Bitte versuche es erneut oder kontaktiere uns.',
  authOfflineLoginError: 'Zum Anmelden ist eine Internetverbindung erforderlich.',
  errorNoInternet: 'Keine Internetverbindung',
  errorServerUnavailable: 'Server nicht erreichbar, bitte melde es uns!',
  errorRequestFailed: 'Anfrage fehlgeschlagen, bitte melde es uns!',
  emailAlreadyVerified: 'E-Mail ist bereits verifiziert',
  emailVerificationRequiredMessage: 'Bitte verifiziere deine E-Mail-Adresse.',
  verificationSendMessage: 'Wir haben einen Verifizierungslink an deine E-Mail-Adresse gesendet.',
  verificationAlreadyDoneMessage: 'E-Mail ist bereits verifiziert, du kannst dich jetzt einloggen.',
  toLoginButtonLabel: 'Zum Login',
  comingSoon: 'Bald verfügbar',
  verifyEmailUnknownError:
    'Es ist ein Fehler beim verifizieren aufgetreten, bitte kontaktiere uns.',
  verifyEmailInvalidTokenError: 'Der Verifizierungslink ist ungültig.',
  verifyEmailSuccess: 'Deine E-Mail-Adresse wurde erfolgreich verifiziert!',
  verifyEmailLoading: 'Verifiziere E-Mail …',
  backToLoginLinkText: 'Zurück zum Login',
  forgotPasswordLinkText: 'Passwort vergessen?',
  loginHeading: 'Login',
  registerHeading: 'Registrieren',
  resetPasswordHeading: 'Passwort\nzurücksetzen',
  loginNoAccountRegisterLink: 'Keinen Account? Jetzt registrieren.',
  registerHaveAccountLoginLink: 'Schon einen Account? Jetzt einloggen.',
  continueButtonLabel: 'Fortsetzen',
  showPasswordLabel: 'Passwort anzeigen',
  hidePasswordLabel: 'Passwort verbergen',
  ssoLoginButtonLabel: 'Login mit %{provider}',
  ssoRegisterButtonLabel: 'Registrieren mit %{provider}',
  sendResetPasswordButtonLabel: 'Passwort zurücksetzen',
  resetPasswordEmailSent:
    'Falls ein Konto mit dieser E-Mail existiert, wurde ein Link zum Zurücksetzen gesendet.',
  resetPasswordCooldown: 'Erneut möglich in %{seconds} s',
  newPasswordPlaceholder: 'Neues Passwort',
  confirmPasswordPlaceholder: 'Passwort bestätigen',
  resetPasswordButtonLabel: 'Passwort zurücksetzen',
  resetPasswordSuccess: 'Dein Passwort wurde erfolgreich zurückgesetzt.',
  resetPasswordInvalidTokenError: 'Dieser Link ist ungültig oder abgelaufen.',
  resetPasswordMismatchError: 'Passwörter stimmen nicht überein.',
  resetPasswordWeakError: 'Passwort ist zu schwach.',
  bulkEditNewCollectionTitle: 'Hinzufügen',
  bulkEditExistingCollectionTitle: 'Bearbeiten',
  bulkEditUnknownError: 'Ein unbekannter Fehler ist aufgetreten',
  bulkEditUnavailableForBundle: 'Massen-Bearbeitung ist für diesen Eintrag nicht verfügbar.',
  bundleSpanAddTitleBundle: 'Bundle hinzufügen?',
  bundleSpanAddTitleSlipcase: 'Schuber hinzufügen?',
  bundleSpanAddConfirm: 'Hinzufügen',
  bundleSpanAddIntroBundle:
    'Für dieses Bundle steht die Massen-Bearbeitung nicht zur Verfügung.\n\nDurch das Hinzufügen erscheinen folgende Einträge in deiner Sammlung:',
  bundleSpanAddIntroSlipcase:
    'Für diesen Schuber steht die Massen-Bearbeitung nicht zur Verfügung.\n\nDurch das Hinzufügen erscheinen folgende Einträge in deiner Sammlung:',
  bundleSpanAddFooterBundle: 'Du kannst das Bundle jederzeit an einem der Einträge entfernen.',
  bundleSpanAddFooterSlipcase: 'Du kannst den Schuber jederzeit an einem der Einträge entfernen.',
  collectionSyncError: 'Sammlung konnte nicht gespeichert werden. Bitte versuche es erneut.',
  sharedCollectionSiblingsUpdated: 'Auch angepasst in: %{titles}',
  sharedCollectionSiblingsAdded: 'Auch hinzugefügt zu: %{titles}',
  sharedCollectionSiblingsRemoved: 'Auch entfernt von: %{titles}',
  releaseSelectionTableOwnedCell: 'Gesammelt',
  releaseSelectionTableReadCell: 'Gelesen',
  readButton: 'Gelesen',
  collectedButton: 'Gesammelt',
  addToCollectionButton: 'Zur Sammlung hinzufügen',
  collectionModalBulkEditCancel: 'Abbruch',
  collectionModalBulkEditCreateNew: 'Hinzufügen',
  collectionModalBulkEditUpdate: 'Speichern',
  myListsHeader: 'Meine Listen',
  explorationHeader: 'Entdecken',
  explorationExploreTab: 'Vorschläge',
  explorationLicensesTab: 'Neue Lizenzen',
  runningReleasesCollectingTabTitle: 'Am Sammeln',
  runningReleasesReadingTabTitle: 'Am Lesen',
  doneReleasesCollectingTabTitle: 'Vollständig',
  pausedReleaseCollectingTabTitle: 'Pausiert',
  pausedReleasesReadingTabTitle: 'Pausiert',
  doneReleasesReadingTabTitle: 'Abgeschlossen',
  planningReleasesTabTitle: 'Geplant',
  abortedReleasesCollectingTabTitle: 'Abgebrochen',
  removedReleasesCollectingTabTitle: 'Entfernt',
  notPlannedReleasesTabTitle: 'Nicht geplant',
  abortedReleasesReadingTabTitle: 'Abgebrochen',
  databaseUpcomingTitle: 'Kommende Titel',
  databasePopularTitle: 'Beliebte Titel',
  databaseRecommendedTitle: 'Empfohlene Titel',
  databaseSearchTitle: 'Suche',
  sortPopularityLabel: 'Beliebtheit',
  sortRecommendationLabel: 'Empfehlung',
  releaseEntryFilterStartDatePickerLabel: 'Erschien nach',
  releaseEntryFilterEndDatePickerLabel: 'Erschien vor',
  releaseEntryFilterDatePickerPlaceholder: 'Datum auswählen',
  releaseEntryFilterDateClear: 'Leeren',
  releaseEntryFilterDateSectionLabel: 'Datum',
  releaseEntryFilterStartDateChipLabel: 'Erscheint ab:',
  releaseEntryFilterEndDateChipLabel: 'Erscheint bis:',
  releaseEntryFilterRelationTypeLabel: 'Typ',
  relationTypeVolume: 'Band',
  relationTypeCollection: 'Schuber/Bundle',
  relationTypeExtra: 'Extra',
  searchPlaceholder: 'Suchen …',
  searchPlaceholderNovelty: 'Neuheiten durchsuchen …',
  searchPlaceholderDatabase: 'Datenbank durchsuchen …',
  scanYourMangaTitle: 'Scanne einen Barcode',
  bulkEditPlannedLabel: 'Geplant',
  bulkModalVolumeLabel: 'Band %{number}',
  bulkModalVolumeLabelWithSuffix: 'Band %{number} · %{volumeSuffix}',
  authPageComingSoonTitle:
    'Die Web-App ist derzeit noch in Entwicklung. Bitte nutze in der Zeit die App.',
  webAccessRestrictedMessage:
    'Sorry! Diese Funktion von atsume steht derzeit leider nur für Unterstützer und Tester zur Verfügung.',
  bulkModalNotReleasedWarning:
    'Du hast Bände ausgewählt, die eigentlich noch nicht erschienen sind!',
  deleteCollectionButton: 'Löschen',
  collectionModalBulkEditAcceptDelete: 'Löschen',
  confirmReleaseDeleteHeader: 'Eintrag löschen?',
  collectionModalDeleteWarningText:
    'Möchtest du diesen Eintrag endgültig löschen? Damit verlierst du dauerhaft deinen Fortschritt.',
  settingsAppSettingsLabel: 'Allgemein',
  settingsAppSettingsDesignLabel: 'Erscheinungsbild',
  settingsAppSettingsDesignAutomatic: 'Automatisch',
  light: 'Hell',
  dark: 'Dunkel',
  settingsAppSettingsStartPageLabel: 'Startseite',
  settingsAppSettingsLanguageLabel: 'Sprache',
  settingsAppNotifications: 'Benachrichtigungen',
  settingsAccountSettingsLabel: 'Account',
  settingsAccountSettingsLogoutLabel: 'Abmelden',
  settingsTestAreaLabel: 'Testbereich',
  settingsListViewLabel: 'Ansicht',
  listViewModeGallery: 'Galerie',
  listViewModeList: 'Liste',
  listViewModeCompact: 'Kompakt',
  settingsInfoLabel: 'Informationen',
  settingsOfflineDataLabel: 'Offline-Modus',
  offlineGateTitle: 'Du bist offline',
  offlineGateMessage:
    'Die Offline-Nutzung ist eine Premium-Funktion. Verbinde dich erneut oder unterstütze uns, um weiterzumachen.',
  offlineGatePremiumCta: 'Atsume unterstützen',
  settingsOfflineLastSyncedLabel: 'Zuletzt synchronisiert',
  settingsOfflineStorageLabel: 'Speicher',
  settingsOfflineSyncing: 'Synchronisiere…',
  settingsOfflineNeverSynced: 'Noch nie',
  settingsOfflineModeLabel: 'Offline-Modus',
  settingsOfflineModeHint:
    'Lädt den Katalog auf dein Gerät, damit die App ohne Internet funktioniert.',
  settingsOfflineModeEnable: 'Offline-Modus aktivieren',
  settingsOfflineConsentTitle: 'Einstellungen für Offline-Modus',
  settingsOfflineConsentTitleProgress: 'Bereite Offline-Modus vor.',
  settingsOfflineConsentMessage:
    'Du kannst den Katalog auf dein Gerät laden, damit die App ohne Internet funktioniert. Der Download läuft im Hintergrund über WLAN. Du kannst die Downloadgröße jederzeit in den Einstellungen anpassen.',
  settingsOfflineConsentOffline: 'Daten',
  settingsOfflineConsentOfflineCovers: 'Daten + Cover',
  settingsOfflineConsentAccept: 'Herunterladen',
  settingsOfflineConsentDecline: 'Später',
  settingsOfflineDownloadingToast: 'Offline-Daten werden heruntergeladen.',
  settingsOfflineWaitingWifi: 'Warte auf WLAN',
  settingsOfflineWaitingWifiHint:
    'Der Offline-Download startet automatisch, sobald du im WLAN bist.',
  settingsOfflineForceDownload: 'Jetzt über Mobilfunk laden',
  offlineDataVanished: 'Offline-Daten nicht mehr vorhanden — du bist wieder online.',
  settingsOfflineForceLabel: 'Offline-Modus erzwingen',
  settingsOfflineUnavailable: 'Nicht verfügbar',
  settingsOfflinePhaseDownloading: 'Lade Daten',
  settingsOfflinePhaseExtracting: 'Entpacke Daten',
  settingsOfflinePhaseApplying: 'Speichere Daten',
  settingsOfflinePhaseMigrating: 'Migriere Daten',
  settingsOfflinePhaseUpdating: 'Aktualisiere',
  settingsOfflinePhaseImages: 'Lade Cover',
  settingsOfflineImagesLabel: 'Cover',
  settingsOfflineImagesEnable: 'Offline-Cover aktivieren',
  settingsOfflineImagesQuality: 'Qualität',
  settingsOfflineImagesQualityLow: 'Niedrig',
  settingsOfflineImagesQualityMedium: 'Mittel',
  settingsOfflineImagesQualityHigh: 'Hoch',
  settingsOfflineImagesStorageLabel: 'Speicher',
  settingsInfoVersionLabel: 'Version',
  optionsModalCancel: 'Abbruch',
  optionsModalOkay: 'Okay',
  optionsModalSave: 'Speichern',
  namePlaceholder: 'Name',
  emailPlaceholder: 'E-Mail',
  passwordPlaceholder: 'Passwort',
  passwordRepeatPlaceholder: 'Passwort wiederholen',
  optionsLoading: 'Lade Optionen',
  serverUnavailableMessage: 'Der Server ist kurz nicht erreichbar. Bitte warte einen Moment …',
  serverUnavailableDiscordCta: 'Auf Discord nachfragen',
  collectionStatus: 'Sammelstatus',
  readingStatus: 'Lesestatus',
  collectStatusPlanned: 'Geplant',
  collectStatusCollecting: 'Laufend',
  collectStatusDone: 'Fertig',
  collectStatusAborted: 'Abgebrochen',
  collectStatusSold: 'Entfernt',
  collectStatusPaused: 'Pausiert',
  readStatusNotPlanned: 'Nicht geplant',
  readStatusPlanned: 'Geplant',
  readStatusReading: 'Laufend',
  readStatusDone: 'Fertig',
  readStatusPaused: 'Pausiert',
  readStatusAborted: 'Abgebrochen',
  selectVolumeVersion: 'Bandversion auswählen',
  selectVolumeOverviewVolumeLabel: 'Exemplar %{number}',
  defaultVolumeSuffix: 'Standard-Edition',
  defaultVolumeSuffixAbr: 'SE',
  ambiguousVolumeIncreaseDetected: 'Bitte wähle eine Version für Band %{number}',
  tmpAddTestLabel: 'Ad testen',
  tmpTestSubscriptionLabel: 'Abo testen',
  dangerZoneLabel: 'Gefahrenzone',
  deleteAccountSettingsLabel: 'Account löschen',
  deleteAccountLabel: 'Löschen',
  confirmDeleteLabel:
    'Bist du sicher, dass du deinen Account löschen möchtest? Dies kann nicht rückgängig gemacht werden.',
  confirmDeleteHeader: 'Account löschen?',
  deletingAccount: 'Account wird gelöscht',
  pleaseEnterText: 'Bitte gib den Text %{text} ein, um fortzufahren.',
  'atsume_ad_free:ad-free-1': 'Keine Werbung (Monatliche Zahlung) - %{price}',
  'atsume_ad_free:ad-free-2': 'Keine Werbung (Jährliche Zahlung) - %{price}',
  adConsentModalHeader: 'Zeit für Werbung',
  adConsentModalBodyText:
    'Wenn du Werbung schaust, geben wir dir Tokens, mit dem du das nächste mal Werbung überspringen kannst. Du kannst atsume auch Werbefrei nutzen, indem du ein Abo abschließt.',
  adConsentModalAmountOfTokens: {
    zero: 'Du hast keine Token.',
    other: 'Du hast noch %{count} Token.',
  },
  adConsentModalCtaBuyAdFree: 'Abo abschließen',
  adConsentModalCtaSkipAd: 'Überspringen (-%{count})',
  adConsentModalCtaUpdatePreferencesToAutoSkipAd:
    'Einstellungen aktualisieren, um Werbung automatisch zu überspringen',
  adConsentModalCtaShowShortAd: 'Kurze Werbung (+%{count})',
  adConsentModalCtaShowLongAd: 'Lange Werbung (+%{count})',
  admobErrorUseAdToken: 'Fehler beim Verwenden des Tokens',
  subscriptionModalHeader: 'Werte dein Erlebnis auf',
  subscriptionModalSubHeader: 'Wähle einen Plan, der zu dir passt.',
  monthly: 'Monatlich',
  yearly: 'Jährlich',
  oneTimeYearly: 'Für ein Jahr',
  bestValue: 'Bestes Angebot',
  perMonth: 'Pro Monat',
  perYear: 'Pro Jahr',
  billedAsYearlyOneTime: 'Nur %{amount} für ein Jahr!',
  billedAsYearly: 'Für nur %{amount} im Jahr!',
  billedAsMonthly: 'Für nur %{amount} im Monat!',
  becomeSupporterNowButtonLabel: 'Jetzt Unterstützer werden',
  choosePlan: 'Plan auswählen',
  youWantToSupportAtsume:
    'Du willst atsume unterstützen? Dann werde jetzt Unterstützer! Dich erwarten viele Vorteile!',
  youWantToSupportUs: 'Du willst uns unterstützen?',
  becomePatronButtonLabel: 'Unterstütze jetzt die App!',
  thankYouForSupporting: 'Danke für deine Unterstützung!',
  youAreAPatron: 'Du bist Unterstützer',
  patron: 'Unterstützer',
  saveMoneyHeader: 'Spare Geld',
  saveMoneyDescription:
    'Erhalte beim Abschluss eines jährlichen Abos ganze zwei Monatszahlungen geschenkt!',
  noPriceIncreaseHeader: 'Keine Preissteigerung',
  noPriceIncreaseDescription:
    'Alle zukünftigen Premium-Features für einen günstigeren Preis – für immer!',
  noAdsHeader: 'Bye-bye, Werbung',
  noAdsDescription:
    'Manga-Tracking ohne nervige Drittanbieter-Werbung, die in Zukunft integriert wird.',
  discordRoleHeader: 'Exklusive Discord-Rolle',
  discordRoleDescription:
    'Erhalte Unterstützerstatus und hebe deine Wünsche in einem exklusiven Kanal hervor.',
  supportDevelopmentHeader: 'Unterstütze die Entwicklung',
  supportDevelopmentDescription:
    'Mit deiner Hilfe halten wir die Datenbank aktuell und arbeiten an weiteren Features!',
  privacyPolicy: 'Datenschutzerklärung',
  termsOfService: 'AGB',
  subscribeAgreePrefix: 'Mit dem Abonnieren stimmst du unseren',
  subscribeAgreeAnd: 'und der',
  subscribeAgreeSuffix: ' zu.',
  restorePurchases: 'Käufe wiederherstellen',
  notNow: 'Jetzt nicht',
  purchaseError: 'Fehler beim Kauf: %{error}',
  loadProductsError: 'Abo-Optionen konnten nicht geladen werden. Bitte versuche es später erneut.',
  admobNoFillLucky: 'Derzeit ist keine Werbung verfügbar. :)',
  addedVolumesToCollection: {
    one: 'Band %{range} zur Sammlung hinzugefügt',
    other: 'Bände %{range} zur Sammlung hinzugefügt',
  },
  activePlan: 'Aktiver Plan',
  showConsentFormLabel: 'Zeige Einwilligungsformular',
  releaseEntryNoDate: 'Noch kein Datum',
  releaseEntryFilterCollectionLabel: 'In meinen Listen',
  releaseEntryFilterCollectionSectionLabel: 'Sammlung',
  releaseEntryFilterNovelties: 'Neue Titel',
  releaseEntryFilterUnowned: 'Nicht im Besitz',
  releaseEntryFilterNoDuplicates: 'Keine Duplikate',
  releaseEntryFilterHidePlanned: 'Kein Geplant',
  releaseEntryFilterHideCollecting: 'Kein Laufend',
  releaseEntryFilterHidePaused: 'Kein Pausiert',
  releaseEntryFilterUnread: 'Ungelesen',
  featureCategoryFilter: 'Merkmale',
  collectionFilterAllDone: 'Aktuell',
  collectionFilterMissing: 'Nicht aktuell',
  collectionFilterGaps: 'Lücken',
  sortByLabel: 'Sortieren',
  collectionFilter: 'Sammlung',
  filterCollectionStatusLabel: 'Nach Sammelstatus',
  filterReadStatusLabel: 'Nach Lesestatus',
  missingIsbnHeaderTitle: 'ISBN nicht gefunden!',
  missingIsbnBody:
    'Wir haben das Buch mit der ISBN %{isbn} nicht in unserer Datenbank gefunden. Bitte gibt im folgenden ein, welcher Titel fehlt. Du wirst den Titel später hinzufügen können, ohne ihn noch ein mal scannen zu müssen.',
  missingIsbnHeaderTitleUpdate: 'ISBN bereits gemeldet',
  missingIsbnBodyUpdate:
    'Du hast die ISBN %{isbn} bereits gemeldet. Wir arbeiten daran, diesen Titel hinzuzufügen. Du kannst deine Beschreibung hier aktualisieren.',
  missingIsbnNotGermanWarning:
    'Diese ISBN sieht nicht nach einer deutschen ISBN aus. Wir fokussieren uns derzeit leider nur auf deutsche Releases. Bist du sicher, dass es ein deutsches Release ist?',
  missingIsbnGermanConfirm: 'Ich versichere, dass dies ein deutsches Release ist.',
  scanError: 'Fehler beim Scannen des Barcodes. Bitte versuche es erneut.',
  scanNotSupported: 'Barcode-Scannen wird auf diesem Gerät nicht unterstützt.',
  cameraPermissionDenied: 'Kameraberechtigung wird benötigt, um Barcodes zu scannen.',
  cameraPermissionDeniedOpenSettings:
    'Kameraberechtigung wurde abgelehnt. Bitte in den Einstellungen aktivieren.',
  couldNotSaveMissingIsbn: 'Fehler beim Speichern der fehlenden ISBN. Bitte versuche es erneut.',
  releaseTypeManga: 'Manga',
  releaseTypeManhwa: 'Manhwa',
  releaseTypeManhua: 'Manhua',
  releaseTypeArtbook: 'Artbook',
  releaseTypeLnovel: 'Light Novel',
  releaseTypeAnimeComic: 'Anime Comics',
  releaseTypeMagazine: 'Magazin',
  releaseStatusRunning: 'Laufend',
  releaseStatusDone: 'Abgeschlossen',
  releaseStatusPaused: 'Pausiert',
  releaseStatusCanceled: 'Eingestellt',
  releaseTabInformation: 'Informationen',
  releaseTabVolumes: 'Bände',
  releaseTabCollections: 'Schuber/Bundles',
  releaseEditButton: 'Bearbeiten',
  releaseShareButton: 'Teilen',
  addToListButton: 'Zu Liste hinzufügen',
  addToListSheetTitleSeries: 'Serie zu Liste hinzufügen',
  addToListSheetTitleVolume: 'Band zu Liste hinzufügen',
  addToListCreateNew: 'Neue Liste erstellen',
  addToListEntryCount: {
    one: '1 Eintrag',
    other: '%{count} Einträge',
  },
  addToListError: 'Liste konnte nicht aktualisiert werden.',
  addToListForSeries: 'Diese Liste ist für Serien',
  addToListForVolumes: 'Diese Liste ist für Bände',
  sharePopupTitle: 'Teilen',
  shareTwitter: 'X',
  shareFacebook: 'Facebook',
  shareWhatsapp: 'WhatsApp',
  shareTelegram: 'Telegram',
  shareReddit: 'Reddit',
  shareEmail: 'E-Mail',
  shareCopyLink: 'Link kopieren',
  shareLinkCopied: 'Link in die Zwischenablage kopiert',
  listsCollectionTabLabel: 'Sammelstatus',
  listsReadTabLabel: 'Lesestatus',
  listsCustomTabLabel: 'Eigene',
  customListsEmptyTitle: 'Keine Listen vorhanden',
  customListsEmptyBody: 'Jetzt eine personalisierte erstellen!',
  customListsLoadFailedTitle: 'Listen konnten nicht geladen werden',
  customListsLoadFailedBody: 'Bitte überprüfe deine Verbindung und versuche es erneut.',
  customListsLoadFailedRetry: 'Erneut versuchen',
  listCreateHeader: 'Neue Liste',
  listEditHeader: 'Liste bearbeiten',
  listFormNameLabel: 'Name',
  listFormDescriptionLabel: 'Beschreibung',
  listFormSettingsLabel: 'Einstellungen',
  listFormPrefilledItemLabel: 'Wird hinzugefügt',
  listFormTypeLockedError: 'Typ kann nicht geändert werden, solange die Liste Einträge enthält.',
  listFormTypeLabel: 'Typ',
  listFormTypeReleaseEntry: 'Serien',
  listFormTypeNovelty: 'Bände',
  listFormPublicLabel: 'Öffentlich',
  listFormRemoveWhenCollectedLabel: 'Entfernen, wenn gesammelt',
  listFormRemoveWhenReadLabel: 'Entfernen, wenn gelesen',
  listFormShowTotalNumberLabel: 'Gesamtanzahl anzeigen',
  listFormShowTotalValueLabel: 'Gesamtwert anzeigen',
  listMetricNoveltyCount: 'Einträge: %{count}',
  listMetricReleaseEntryCount: 'Reihen: %{series} · Bände: %{volumes}',
  listMetricValue: '%{value} €',
  listFormCustomTagLabel: 'Benutzerdefinierter Tag',
  listFormCustomTagNameLabel: 'Tag-Name',
  listFormSaveLabel: 'Speichern',
  listFormNameRequiredError: 'Bitte gib einen Namen ein.',
  listFormCustomTagRequiredError: 'Bitte gib einen Tag-Namen ein.',
  listFormDeleteLabel: 'Löschen',
  listFormDeleteError: 'Liste konnte nicht gelöscht werden.',
  listDeleteConfirmHeader: 'Liste löschen',
  listDeleteConfirmBody:
    'Diese Liste und alle zugehörigen Einträge werden dauerhaft gelöscht. Das kann nicht rückgängig gemacht werden.',
  listFormSaveError: 'Liste konnte nicht gespeichert werden.',
  createListAction: 'Liste erstellen',
  customListLimitReachedToast: 'Limit für Listen ist erreicht. Werde Unterstützer für mehr!',
  editListAction: 'Liste bearbeiten',
  listNotFoundTitle: 'Liste nicht gefunden',
  listNotFoundBody: 'Diese Liste existiert nicht oder wurde gelöscht.',
  listNotFoundAction: 'Zurück zu meinen Listen',
  databaseEmptyConfigs: 'Es sind aktuell keine Datenbank-Listen konfiguriert.',
  artbook: 'Artbook',
  lnovel: 'Light Novel',
  animeComic: 'Anime Comics',
  magazine: 'Magazin',
  manga: 'Manga',
  manhua: 'Manhua',
  manhwa: 'Manhwa',
  isbnLabel: 'ISBN',
  mediumType: 'Medium',
  pagesLabel: 'Seiten',
  formatLabel: 'Format',
  sizesLabel: 'Maße',
  originalDataLabel: 'Originaldaten',
  titleLabel: 'Titel',
  publisherLabel: {
    one: 'Verlag',
    other: 'Verlage',
  },
  magazineLabel: {
    one: 'Magazin',
    other: 'Magazine',
  },
  statusLabel: 'Status',
  volumesLabel: 'Bände',
  originCountryLabel: 'Herkunft',
  empty: '',
  canceled: 'Eingestellt',
  completed: 'Abgeschlossen',
  running: 'Laufend',
  statusChangeRead: `Lesestatus von %{oldStatus} auf %{newStatus} gesetzt.`,
  statusChangeCollection: `Sammelstatus von %{oldStatus} auf %{newStatus} gesetzt.`,
  de: 'Deutschland',
  fr: 'Frankreich',
  zh: 'China',
  tw: 'Taiwan',
  jp: 'Japan',
  it: 'Italien',
  es: 'Spanien',
  eu: 'Europa',
  gb: 'Vereinigtes Königreich',
  ko: 'Südkorea',
  us: 'Vereinigte Staaten',
  testAreaImportLabel: 'Sammlung importieren',
  importTitle: 'Sammlung importieren',
  importStepSourceTitle: 'Quelle wählen',
  importStepUploadTitle: 'Datei hochladen',
  importStepMappingTitle: 'Felder zuordnen',
  importStepMatchingTitle: 'Abgleich',
  importStepPreviewTitle: 'Vorschau',
  importStepCommittingTitle: 'Import läuft',
  importStepResultTitle: 'Ergebnis',
  importSourceBookshelf: 'Bookshelf - von SquidBit (CSV)',
  importSourceReado: 'READO (JSON)',
  importSourceCustom: 'Atsume (CSV)',
  importInstructionsBookshelf:
    'Öffne Bookshelf → Gehe zu Einstellungen → Tippe auf Import und Export → Tippe auf Exportieren → Wähle csv. als Dateityp und markiere alle Regale → Tippe auf Exportieren → Lade die exportierte Datei hier hoch',
  importInstructionsReado:
    'Klicke auf den "Anfrage-Text kopieren" Button → Öffne Reado app → Tippe auf Profil unten → Tippe auf das Burgermenü rechts oben → Tippe auf Einstellungen → Tippe auf "Kundensupport Chat" → Füge den Text aus der Ablage ein und fordere damit deine Daten an → Sobald du die JSON-Datei erhältst, lade sie hier hoch. Dies kann bis zu ein paar Tage dauern. → Die JSON-Datei enthält sensible Daten. Die App liest nur ISBN und Listenstrukturen aus und überträgt nichts davon an unsere Server.',
  importReadoCopyButton: 'Anfrage-Text kopieren',
  importReadoCopied: 'Kopiert!',
  importReadoRequestText:
    'Hallo, ich möchte gemäß DSGVO Artikel 15 eine Kopie meiner personenbezogenen Daten anfordern. Bitte senden Sie mir den Export meiner READO-Kontodaten in einem maschinenlesbaren Format. Vielen Dank.',
  importInstructionsAtsume:
    'Erstelle eine CSV mit Spalten: isbn, list_name, collection_status, read_status, is_collected, is_read. (Andere Spalten werden ignoriert.) → Lade die Datei hier hoch.',
  importDownloadExample: 'Beispiel herunterladen',
  importPickFileButton: 'Datei auswählen',
  importFilePickedLabel: '%{name} · %{rows} Zeilen',
  importFileTooLargeWarning: 'Über 5000 Zeilen — Import kann lange dauern.',
  importFileParseError: 'Datei konnte nicht gelesen werden.',
  importMappingExplanation: 'Ordne jeden Wert einem Sammel-/Lesestatus zu.',
  importMappingIgnore: 'Ignorieren',
  importMappingCollectionStatus: 'Sammelstatus',
  importMappingReadStatus: 'Lesestatus',
  importMatchingProgress: 'Suche %{done} von %{total} ISBNs …',
  importPreviewTabNew: 'Neu (%{count})',
  importPreviewTabConflicts: 'Konflikte (%{count})',
  importPreviewTabUnmatched: 'Ohne Treffer (%{count})',
  importPreviewSearchPlaceholder: 'Nach Titel suchen',
  importPreviewVolumesLine: '%{count} Bände',
  importPreviewIncludeRow: 'Importieren',
  importConflictSkip: 'Überspringen',
  importConflictOverwrite: 'Überschreiben',
  importNextButton: 'Weiter',
  importBackButton: 'Zurück',
  importStartButton: 'Import starten',
  importCommittingProgress: 'Importiere %{done} von %{total} …',
  importResultTitle: 'Import abgeschlossen',
  importResultCreated: 'Neu hinzugefügt',
  importResultOverwritten: 'Überschrieben',
  importResultSkipped: 'Übersprungen',
  importResultUnmatched: 'Ohne Treffer',
  importResultDownloadReport: 'Bericht herunterladen',
  importResultDoneButton: 'Fertig',
  importEmptyState: 'Keine Einträge in dieser Liste.',
  importNoSourceSelected: 'Bitte wähle zuerst eine Quelle.',
  importMissingIsbnNote: 'Importiert aus %{source}',
  importBucketWishlist: 'Wunschliste',
  importBucketUnlabeled: 'Ohne Kategorie',
  importPreviewCollections: '%{count} Collections',
  importPreviewEmptyNew: 'Keine neuen Einträge.',
  importPreviewEmptyConflicts: 'Keine Konflikte.',
  importPreviewEmptyUnmatched: 'Alle ISBNs gefunden.',
  notificationsTitle: 'Benachrichtigungen',
  notificationsEmpty: 'Keine Benachrichtigungen',
  notificationSettingsTitle: 'Einstellungen',
  notificationSettingsDisabledHint:
    'Aktiviere Benachrichtigungen, um Updates zu deiner Sammlung zu erhalten.',
  notificationSettingsEnableButton: 'Benachrichtigungen aktivieren',
  notificationSettingsDisableButton: 'Benachrichtigungen deaktivieren',
  notificationSettingsEnabled: 'Benachrichtigungen aktiviert',
  notificationSettingsDisabled: 'Benachrichtigungen deaktiviert',
  notificationSettingsDenied: 'Benachrichtigungen abgelehnt',
  notificationSettingsCollectionHeader: 'Sammlung',
  notificationSettingsNewReleasesHeader: 'Neuheiten',
  notificationSettingsAddedReleaseDate: 'Neues Erscheinungsdatum',
  notificationSettingsChangedReleaseDate: 'Geändertes Erscheinungsdatum',
  notificationSettingsItemAvailable: 'Band erscheint',
  notificationSettingsAlternativeVersion: 'Edition eines Bandes erscheint',
  notificationSettingsScannerHeader: 'Scanner',
  notificationSettingsScannedItemAvailable: 'Gemeldete ISBN ist jetzt im Katalog',
  notificationSettingsAtsumeHeader: 'atsume',
  notificationSettingsAtsumeRecommendations: 'Vorschläge',
  notificationSettingsFromPublishers: 'Ausgewählte Verlage',
  notificationSettingsFromAuthors: 'Ausgewählte Autoren/Zeichner',
  notificationSettingsAddPublisher: 'Verlag hinzufügen',
  notificationSettingsAddAuthor: 'Autor/Zeichner hinzufügen',
  notificationSettingsSearchPublisher: 'Verlag suchen',
  notificationSettingsSearchAuthor: 'Autor/Zeichner suchen',
  notificationSettingsSaved: 'Einstellungen gespeichert',
  notificationSettingsSaveError: 'Fehler beim Speichern',
}
